{
  "activeDevicesInView": "Dispositivi attivi in vista",
  "deviceProfileLinkText": "Maneggio",
  "controlPanelLinkText": "Controlli",
  "automationDescription": {
    "notifyFalse": "Quando il sensore {{sourceSensor}} di {{sourceDeviceName}} cambia da {{sourceSensorStatePrevious}} a {{sourceSensorStateCurrent}}, {{targetDeviceName}} dovrebbe {{namedDeviceAction}}.",
    "notifyTrue": "Quando il sensore {{sourceSensor}} di {{sourceDeviceName}} cambia da {{sourceSensorStatePrevious}} a {{sourceSensorStateCurrent}}, {{targetDeviceName}} dovrebbe {{namedDeviceAction}} e inviare una notifica SMS."
  },
  "currentStatus": "Stato attuale",
  "deviceActivity": {
    "currentStatus": "Stato attuale",
    "linkTo": "Attività",
    "recentActivity": "Attività recenti",
    "title": "Attività del dispositivo"
  },
  "deviceInFieldWithFieldName": "Nel campo {{fieldName}}",
  "deviceLocationUnknown": "Posizione del dispositivo sconosciuta",
  "deviceOffline": "Dispositivo offline",
  "deviceUnreachable": "Dispositivo irraggiungibile",
  "deviceUnreachableDescription": "Impossibile raggiungere questo dispositivo dopo diversi tentativi. I comandi sono sospesi fino al {{date}}.",
  "clearUnreachable": "Cancella e riprova",
  "deviceErrorTimedOut": "Il dispositivo ha impiegato troppo tempo per rispondere.",
  "deviceErrorUnreachable": "Impossibile raggiungere il dispositivo.",
  "deviceErrorDidNotRespond": "Il dispositivo non ha risposto.",
  "deviceErrorReturnedFailure": "Il dispositivo non è riuscito a completare la richiesta.",
  "deviceProfile": "Profilo del dispositivo",
  "deviceRosterHelpContentBodyText": "In questo elenco vengono visualizzati tutti i dispositivi appartenenti alla tua farm.\n\nFai clic/tocca un dispositivo per visualizzarne il profilo, dove puoi visualizzare e modificare i valori di configurazione del dispositivo, visualizzare le analisi del dispositivo e altro ancora.",
  "deviceRosterHelpContentTitle": "Elenco dispositivi",
  "deviceRosterListEmpty": "Il tuo account farm non ha dispositivi",
  "deviceRosterSortMenuTitle": "Ordina dispositivi per",
  "deviceRosterTitle": "Dispositivi",
  "deviceRosterTitleWithItemCount": "Dispositivi ({{itemCount}})",
  "deviceSortKeys": {
    "alphabetical": "Nome dispositivo",
    "device_activity": "Attività",
    "device_installation_type": "Tipo di installazione"
  },
  "eventsUpdated": "Eventi aggiornati",
  "forceUpdate": "Aggiorna dati",
  "goToFieldProfile": "Vai al profilo del campo",
  "inFieldWithColon": "Nel campo:",
  "locationWithColon": "Posizione:",
  "manageDeviceLinkText": "Maneggio",
  "openLocationNavigation": "Apri opzioni di navigazione",
  "noActiveDevicesInView": "Nessun dispositivo attivo in vista",
  "noCommandsFoundForDevice": "Nessun comando trovato per questo dispositivo",
  "noConnections": "Nessuna connessione creata per questo dispositivo",
  "noEvents": "Nessuna attività rilevata dai dispositivi della tua fattoria. Controlla più tardi per nuovi aggiornamenti.",
  "noGps": "Nessun GPS",
  "over24HoursAgo": "Oltre 24 ore fa",
  "pivotLegendArm": "Braccio del pivot (posizione attuale)",
  "pivotLegendEndGun": "Cannone finale attivo",
  "pivotLegendLastKnown": "Ultima posizione nota (non aggiornata)",
  "pivotLegendSweptArea": "Area percorsa in questo ciclo",
  "pivotLegendTitle": "Legenda della mappa",
  "pivotLegendWater": "Acqua attiva (bagnato)",
  "pivotNextStopWithVal": "Prossima: {{val}}",
  "pivotStale": "Non aggiornato",
  "pivotTimeToStopWithVal": "{{val}} all'arresto",
  "recentActivity": "Attività recenti",
  "reelSpeed": {
    "max": {
      "defaultValueHint": "Un buon punto in cui impostare la velocità massima è 10 volte la tipica velocità di ritrazione.",
      "description": "Se la velocità del mulinello supera la velocità massima, considereremo il mulinello in estensione."
    },
    "min": {
      "defaultValueHint": "Un buon punto in cui impostare la velocità minima è 1/3 della tipica velocità di ritrazione.",
      "description": "Se la velocità del mulinello scende al di sotto della velocità minima, considereremo il mulinello fermo e adotteremo le azioni da te configurate."
    }
  },
  "requestUpdateButton": "Richiedi aggiornamento",
  "runComplete": "Esecuzione completata",
  "runEtaWithTimestamp": "ETA: {{val, datetime}}",
  "runProgressFractionWithUnitLabel": "{{distanceElapsed}}/{{distanceMax}} {{unitLabel}}",
  "runStopped": "Fermato",
  "runStoppedShort": "Fermato di colpo",
  "sensorStateUnknownWithSensorName": "{{sensorName}} Sconosciuto",
  "sensorStateWithSensorReading": "{{sensorState}} ({{sensorReading}})",
  "sensorStateWithSensorReadingAndUnitLabel": "{{sensorState}} ({{sensorReading}} {{unitLabel}})",
  "setCenterPivotPathCenterMarkerLabel": "Centro",
  "setCenterPivotPathLinkTo": "Imposta contorno",
  "setCenterPivotPathNotSetWarning": "Contorno del perno centrale non configurato. Imposta un contorno per abilitare le funzionalità di tracciamento del perno centrale.",
  "setCenterPivotPathSetCenterInstructions": "Tocca la mappa per impostare la posizione del perno centrale",
  "setCenterPivotPathTitle": "Imposta il contorno del perno centrale",
  "setPidSetpointFormAdvancedLabel": "Impostazioni PID (Avanzato)",
  "setPidSetpointFormDisclaimerAcknowledgement": "Riconosco di essere responsabile della sicurezza dell'attrezzatura e del personale quando imposto la velocità di tracciamento VFD.",
  "setPidSetpointFormDisclaimerBody": "Questa è una funzione sperimentale. Questa funzione tenterà di raggiungere e mantenere la pressione target il più rapidamente possibile modificando automaticamente l'impostazione della velocità VFD.",
  "setPidSetpointFormSetPointInputLabel": "Punto di riferimento",
  "setPressurePidSetpointFormTitle": "Mantenere la pressione",
  "setVfdSpeedFormFrequencyLabel": "Velocità (percentuale)",
  "setVfdSpeedFormImmediateLabel": "Immediato",
  "setVfdSpeedFormInstructions": "Specificare la percentuale desiderata e il tempo di rampa.",
  "setVfdSpeedFormMinutesInputLabel": "Minuti",
  "setVfdSpeedFormRamp": "Rampa",
  "setVfdSpeedFormRampLabel": "Rampa",
  "setVfdSpeedFormRampTimeInstructions": "Tempo di rampa",
  "setVfdSpeedFormSecondsInputLabel": "Secondi",
  "setVfdSpeedFormTitle": "Imposta la velocità VFD",
  "showAllDevices": "Mostra tutti i dispositivi",
  "title": "Stato del dispositivo",
  "updateRequested": "Aggiornamento richiesto dal dispositivo...",
  "vfd": {
    "off": "VFD spento",
    "on": "VFD acceso",
    "over": "VFD sopra",
    "ramping": "Rampa VFD",
    "title": "Variatore di frequenza",
    "trackingWithValue": "Tracciamento di {{value}} {{unit}}",
    "under": "VFD sotto"
  },
  "waitingForUpdate": "In attesa di aggiornamenti...",
  "deviceAlias": "Alias del dispositivo"
}
